import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { MedicationPrescription } from '../../models/medication-prescription';

@Injectable({
  providedIn: 'root',
})
export class MedicationPrescriptionsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientMedicationPrescriptionsEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientMedicationPrescriptions`;

  getPatientMedicationPrescriptions(medicationId: number, patientId: number): Observable<MedicationPrescription[]> {
    const url = `${this.patientMedicationPrescriptionsEndpoint}?patientMedicationId=${medicationId}&patientId=${patientId}`;
    return this.utilityService.getRequest<MedicationPrescription[]>(url);
  }
}
